export type ValidateImageParams = {
  file: File | File[];
  validation: {
    mbSize: number;
    extensions: string[];
    countLimit: number;
    maxDimension: number;
  };
};

interface ImageValidationResult {
  isValid: boolean;
  type?: 'count' | 'size' | 'extension' | 'dimension';
}

export const validateImage = async ({
  validation,
  file,
}: ValidateImageParams): Promise<ImageValidationResult> => {
  const { mbSize, extensions, countLimit, maxDimension } = validation;

  const files = Array.isArray(file) ? file : [file];

  // 개수 초과
  if (files.length > countLimit) {
    return {
      isValid: false,
      type: 'count',
    };
  }

  for (const file of files) {
    const fileSize = file.size;
    const fileExtension = file.type.split('/').pop() || '';

    // 이미지 확장자 불일치
    if (!extensions.includes(fileExtension)) {
      return {
        isValid: false,
        type: 'extension',
      };
    }

    // 파일 용량 초과
    if (fileSize > mbSize * 1024 * 1024) {
      return {
        isValid: false,
        type: 'size',
      };
    }

    // 이미지 크기 초과
    const { width, height } = await createImageBitmap(file);

    if (width >= maxDimension || height >= maxDimension) {
      return {
        isValid: false,
        type: 'dimension',
      };
    }
  }

  return {
    isValid: true,
  };
};
